// extracted by mini-css-extract-plugin
export default {"assignPropertyPage":"AssignPropertyPage_assignPropertyPage__dKalG","assignButton":"AssignPropertyPage_assignButton__xohkA"};